module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-100-Classes-Active-8e97ef86f90eb5d6ccc25ae86939de0d.png";